import { Row } from '~components/table-view';
import SahServiceCell from '~support-at-home/components/config/service-associations/SahServiceCell';

/**
 * The Support at Home service on a cutover row, with the same reference detail behind the same info
 * icon as the associations screen.
 *
 * A thin adapter rather than a second implementation: `SahServiceCell` reads the service name from
 * `row.name`, and on these rows `name` is the LOCAL service type - the government service is in
 * `service_name`. Reshaping the row here keeps one popover, one set of fields and one place to
 * change them, rather than a near-copy that drifts the first time a field is added.
 */
const CutoverSahServiceCell = ({ row }: { row: Row }) =>
  SahServiceCell({
    row: {
      id: `${row.from_service_id}-${row.service_type_id}`,
      name: row.service_name,
      service_info: row.service_info,
    },
  });

export default CutoverSahServiceCell;
